import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { SiteNav } from "@/components/site/SiteNav";
import { SiteHero } from "@/components/site/SiteHero";
import { ProductsGrid } from "@/components/site/ProductsGrid";
import { UserTypes } from "@/components/site/UserTypes";
import { EcosystemFlow } from "@/components/site/EcosystemFlow";
import { FunzAI } from "@/components/site/FunzAI";
import { Creators } from "@/components/site/Creators";
import { LoanNova } from "@/components/site/LoanNova";
import { Enterprise } from "@/components/site/Enterprise";
import { GreenNova } from "@/components/site/GreenNova";
import { SiteTestimonials } from "@/components/site/SiteTestimonials";
import { Pricing } from "@/components/site/Pricing";
import { DownloadApp } from "@/components/site/DownloadApp";
import { SiteFooter } from "@/components/site/SiteFooter";

export default function FunzSite() {
  useEffect(() => {
    document.title = "FUNZ — The Gen Z Economic Operating System";
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div
      data-testid="funz-site"
      className="min-h-screen bg-[#09090B] text-white antialiased"
    >
      <div className="noise-overlay" aria-hidden="true" />
      <SiteNav />
      <main>
        <SiteHero />
        <ProductsGrid />
        <UserTypes />
        <EcosystemFlow />
        <FunzAI />
        <Creators />
        <LoanNova />
        <Enterprise />
        <GreenNova />
        <SiteTestimonials />
        <Pricing />
        <DownloadApp />
      </main>
      <SiteFooter />
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}
